module.exports = __webpack_public_path__ + "img/mediaportal_uploads.51d7c2c7.jpg";